/**
 * Test IDs for QA automation.
 */
export const testIds = {
  userListCreateAdmin: "user-list-create-admin",
  userListCreateDriver: "user-list-create-driver",
  userListCreateAdminDriver: "user-list-create-admin-driver",
  userListAdminsNavigation: "user-list-admins-navigation",
  userListAdminsView: "user-list-admins-view",
  userListDrivers: "user-list-drivers",
  userListMany: "user-list-many",
  userListNewGroup: "user-list-new-group",
} as const;
